import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsLinkComponent } from './components/link/link.component';

@NgModule({
  declarations: [DsLinkComponent],
  imports: [CommonModule],
  exports: [DsLinkComponent],
})
export class DsLinkModule {}
